import { Box, Button, InputLabel, styled } from "@mui/material"

export const StyledInputLabel = styled(InputLabel)({
  ".MuiInputLabel-shrink": { visibility: "none", opacity: 0, color: "yellow" },
  // marginBottom: "100px !important"
  fontSize: 14,
  marginTop: "-7px",
})

export const groupInfoIconStyle = {
  color: "#3C77EF",
  height: "30px",
  width: "30px",
  border: " 1px solid #DCDCDD",
  borderRadius: "4px ",
  padding: "2px",
}

export const GroupInfoWrapper = styled(Box)({
  height: "100%",
  boxShadow: "0px 2px 8px #00000022",
  borderRadius: " 4px",
  opacity: 1,
})

export const GroupInfoHeader = styled(Box)({
  borderBottom: "1px solid #EFF0F5",
  padding: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  // border: "1px solid red"
})

export const GroupInfoHeaderLeft = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
})

export const GroupInfoHeaderIconWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
})

export const GroupInfoHeaderIconActiveButton = styled(Button)({
  width: "60px",
  height: "18px",
  border: "1px solid ",
  borderRadius: "4px",
  marginTop: "10px",
  opacity: 1,
  // color: "#42B2A0",
  // backgroundColor: "#E6F8E9",
  fontSize: "10px",
  fontFamily: "Poppins",
})

export const GroupInfoContact = styled(Box)({
  // border: "1px solid red",
  padding: "15px",
  width: "100%",
  // height: "234px",
  borderBottom: "1px solid #EFF0F5",
  display: "flex",
  flexDirection: "column",
})

export const GroupInfoContactSectionOne = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  // border: "1px solid red"
})

export const GroupInfoContactSectionOneLeft = styled(Box)({
  // border: "1px solid red"
})

export const GroupInfoContactSectionOneRight = styled(Box)({
  // width: "50%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-around",
})

export const GroupInfoContactSectionTwo = styled(Box)({
  // width: "100%",
  // height: "100%",
  // display: "flex",
  // justifyContent: "space-between",
  // flexDirection: "row",
  // border: "1px solid red",
  // padding: "0px 0px 0px 33px",
  marginTop: "10px",
})

export const GroupInfoContactSectionThree = styled(Box)({
  // width: "100%",
  // height: "100%",
  // display: "flex",
  // justifyContent: "space-between",
  // flexDirection: "row",
  // border: "1px solid red",
  // padding: "0px 0px 0px 33px",
  marginTop: "10px",
})

export const GroupInfoAdvisor = styled(Box)({
  // display: "flex",
  width: "100%",
  // height: "100%",
  flexDirection: "row",
  marginTop: "16px",
  // height: "104px",
  borderBottom: "1px solid #EFF0F5",
  padding: "0 15px",
  justifyContent: "space-between",
  // border: "1px solid red"
})

export const GroupInfoAdvisorLeft = styled(Box)({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  // border: "1px solid red"
})

export const GroupInfoAdvisorRight = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  // flex: 1,
  // width: "50%",
  // border: "1px solid red"
})

export const GroupInfoCsm = styled(Box)({
  display: "flex",
  width: "100%",
  flexDirection: "row",
  borderBottom: "1px solid #EFF0F5",
  padding: "0 15px",
  marginTop: "16px",
  justifyContent: "space-between",
  // height: "100%",
  // height: "104px",
  // border: "1px solid red"
})

export const GroupInfoCsmLeft = styled(Box)({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  // border: "1px solid red"
})

export const GroupInfoCsmRight = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  // border: "1px solid red"
  // flex: 1,
  // width: "50%",
})

export const GroupInfoRegion = styled(Box)({
  padding: "0 15px",
  width: "100%",
  marginTop: "16px",
  display: "flex",
  flexDirection: "column",
  borderBottom: "1px solid #EFF0F5",
})

export const GroupInfoRegionSectionOne = styled(Box)({
  display: "flex",
  flexDirection: "column",
  // width: "100%",
  // height: "50%"
})

export const GroupInfoRegionSectionOneLeft = styled(Box)({
  // padding: "15px 0px 0px 33px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
})

export const GroupInfoRegionSectionTwo = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  marginTop: "16px",
})

export const GroupInfoRegionSectionTwoLeft = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
})

export const GroupInfoRegionSectionTwoRight = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
})

export const GroupInfoDeactivate = styled(Box)({
  // flex: 1,
  display: "flex",
  padding: "15px",
  // alignItems: "flex-start",
  // height: "100%"
  // border: "1px solid red",
  // marginTop: "auto",
  // justifyContent: "center",
})

export const GroupInfoDeactivateButton = styled(Button)({
  width: "100%",
  height: "40px",
  border: "1px solid #E48081",
  borderRadius: "4px",
  opacity: 1,
  color: "#F3797E",
  backgroundColor: "#E480811A",
  fontSize: "14px",
  textTransform: "capitalize",
  fontFamily: "Poppins",
})

export const DentalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="43.019"
    height="43"
    viewBox="0 0 43.019 43"
  >
    <g id="dental" transform="translate(0 -0.11)">
      <path
        id="Path_12421"
        data-name="Path 12421"
        d="M42.178,38.056H39.644V13.584h2.534a.841.841,0,0,0,.8-1.106L40.444,4.885a.84.84,0,0,0-.8-.575H29.133A4.862,4.862,0,0,0,21.7.881a.355.355,0,0,1-.376,0,4.857,4.857,0,0,0-7.436,3.43H3.372a.84.84,0,0,0-.8.575L.043,12.478a.841.841,0,0,0,.8,1.106H3.375V38.056H.841A.84.84,0,0,0,0,38.9V42.27a.84.84,0,0,0,.84.84H42.178a.84.84,0,0,0,.84-.84V38.9A.84.84,0,0,0,42.178,38.056ZM41.012,11.9H27.371c.369-4.159,1.3-4.06,1.7-5.912h9.973ZM18.654,1.792H18.7a3.164,3.164,0,0,1,1.715.5,2.03,2.03,0,0,0,2.194,0,3.165,3.165,0,0,1,1.715-.5h.043a3.178,3.178,0,0,1,2.764,4.664,11.786,11.786,0,0,0-1.4,4.949L25.6,12.887a3.213,3.213,0,0,1-1.43,2.388c-.056.039-.1-.025-.106-.1L23.655,11.1a1.956,1.956,0,0,0-3.893.028l-.4,4.051a.1.1,0,0,1-.15.074,3.19,3.19,0,0,1-1.51-2.27l-.27-1.827a11.727,11.727,0,0,0-1.5-4.623,3.175,3.175,0,0,1-.41-1.665,3.207,3.207,0,0,1,3.132-3.077ZM3.977,5.991h9.972c.43,2,1.223,1.376,1.892,5.912H2.006ZM5.055,23.707h9.287v9.287H5.055Zm0,10.967H15.182a.84.84,0,0,0,.84-.84V22.867a.84.84,0,0,0-.84-.84H5.055V13.584H16.1a4.861,4.861,0,0,0,2.235,3.108,1.569,1.569,0,0,0,.912.267,1.783,1.783,0,0,0,1.78-1.612l.4-4.046a.292.292,0,0,1,.276-.27.274.274,0,0,1,.273.242l.4,4.07a1.783,1.783,0,0,0,1.78,1.612h0a1.645,1.645,0,0,0,.784-.189,4.9,4.9,0,0,0,2.236-3.182H37.963V38.056H34.582V25.395h.847a.84.84,0,0,0,.84-.84V21.18a.84.84,0,0,0-.84-.84h-13.5a.84.84,0,0,0-.84.84v3.375a.84.84,0,0,0,.84.84h.847V38.055H5.055Zm19.4,3.381V25.395H27.84V38.056ZM22.771,23.714V22.02H34.589v1.694H22.771Zm6.749,1.68H32.9V38.056H29.52ZM41.338,41.43H1.681V39.736H41.338Z"
        transform="translate(0)"
        fill="#707071"
      />
    </g>
  </svg>
)
